<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Add memory image</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block spinner-parent">
                <spinner ref="spinner" size="md" text="Loading ..." />
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2" for="default">Type *</label>
                  <div class="col-md-10">
                    <select id="default" v-model="entity.is_person" class="form-control">
                      <option v-for="(type, idx) in personTypes" :key="idx" :value="type.isPerson">
                        {{ type.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="bio" class="col-md-2">Image *</label>
                  <div class="col-md-10">
                    <image-uploader
                      ref="uploader"
                      :uploaded-img-url="source.image ? source.image.public_url : null"
                      :removable="false"
                      @changeFile="coverChange"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-2" for="default">Reference Image</label>
                  <div class="col-md-10">
                    <select id="default" v-model="entity.ref_id" class="form-control">
                      <option v-for="image in images" :key="image.id" :value="image.id">
                        {{ `${image.id} ${image.title}` }}
                      </option>
                    </select>
                  </div>
                </div>
                <template v-for="(quote, key) in entity.quotes">
                  <MemoryQuote
                    :key="key"
                    :quote="quote"
                    :number="key"
                    @deleteQuote="onDeleteQuote"
                  />
                </template>
                <button class="btn btn-success" @click="addQuote">
                  Add Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Memory image has added successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import MemoryGameMixin from '@/mixins/MemoryGameMixin';
import MemoryQuote from './MemoryQuote.vue';

export default {
  name: 'MemoryImageNew',

  components: {
    MemoryQuote,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests, MemoryGameMixin],

  mounted() {
    if (!this.images.length) {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.getAllImages()
        .then((response) => {
          const memoryImages = _.cloneDeep(response.data);
          delete memoryImages.meta;
          const images = Object.keys(memoryImages).map(e => memoryImages[e]);
          this.$store.dispatch('memoryGame/setImages', images);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        });
    }
  },

  methods: {
    isEntityValid() {
      const filelds = [
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Image', value: this.entity.memory_image, type: 'required' },
      ];
      return this.$_validate(filelds);
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', JSON.stringify(this.entity.quotes));
      postFormData.append('is_person', this.entity.is_person ? 1 : 0);
      postFormData.append('memory_image', this.entity.memory_image);
      if (this.entity.ref_id) {
        postFormData.append('ref_id', this.entity.ref_id);
      }
      return this.$apiHttp.post(`${this.$config.app_api.prefix}games/memory`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/memory-game-images/edit/${response.data.id}`;
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
    coverChange(file) {
      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = () => {
          this.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.memory_image = file;
        return;
      }
      this.imageSelected = false;
    },
    getAllImages() {
      return this.$apiHttp.get(`${this.$config.app_api.prefix}games/memory`, {
        params: {
          nonpaginated: true,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?266da856